import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  departments: [],
  department: null
}

// mutations
export const mutations = {
  [types.SET_DEPARTMENTS] (state, departments) {
    state.departments = departments
  },
  [types.SET_DEPARTMENT] (state, department) {
    state.department = department
  },
  [types.FETCH_DEPARTMENT_FAILURE] (state) {
    state.department = null
  }
}

// actions
export const actions = {
  async fetchDepartments ({ commit }) {
    try {
      const { data } = await axios.get('/departments?include=country')
      commit(types.SET_DEPARTMENTS, data)
    } catch (e) {
      console.log(e)
    }
  },
  async fetchDepartment ({ commit }, department) {
    try {
      const { data } = await axios.get(`/departments/${department.id}`)

      commit(types.SET_DEPARTMENT, { department: data })
    } catch (e) {
      commit(types.FETCH_DEPARTMENT_FAILURE)
    }
  },

  async createDepartment (context, department) {
    try {
      await axios.post('/api/departments', department)
      context.dispatch('fetchDepartments')
    } catch (e) {
      console.log(e)
    }
  },

  async updateDepartment (context, department) {
    try {
      await axios.put(`/api/departments/${department.id}`, department)
      context.dispatch('fetchDepartments')
    } catch (e) { }
  },

  async deleteDepartment (context, department) {
    try {
      await axios.delete(`/api/departments/${department.id}`)
      context.dispatch('fetchDepartments')
    } catch (e) { }
  }
}

// getters
export const getters = {
  departments: state => state.departments
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/department.js